import { MainLayout } from "../components/layouts/MainLayout.tsx";
import UtilsHelper from "../helpers/utilsHelper.ts";

const PrivacyPolicy = () => {
    UtilsHelper.changeWindowDocumentTitle("Polityka prywatności");
    return (
        <MainLayout>
            <div className={"p-4 pt-20 md:p-4 md:pt-4 max-w-5xl space-y-4 flex-grow"}>
                <h1 className={"text-2xl"}>Polityka Prywatności</h1>
                <div className={"w-28 rounded-full h-0.5 bg-[#008DD2]"} />
                <p>Niniejsza polityka prywatności określa zasady przetwarzania danych osobowych oraz wykorzystywania
                    plików cookie na stronie internetowej zarządzanej przez Beskid Media sp. z o.o. z siedzibą w Kętach.
                    Dbamy o ochronę prywatności i dokładamy wszelkich starań, aby chronić dane osobowe naszych
                    użytkowników zgodnie z obowiązującymi przepisami prawa.
                </p>
                <h2 className={"text-xl"}>1. Administrator Danych Osobowych</h2>
                <p>Administratorem danych osobowych jest Beskid Media sp. z o.o. z siedzibą pod adresem: ul. Tadeusza
                    Kościuszki 115, 32-650 Kęty, wpisana do rejestru przedsiębiorców Krajowego Rejestru Sądowego
                    prowadzonego przez Sąd Rejonowy dla Kraków-Śródmieście w Krakowie XXII Wydział Gospodarczy Krajowego
                    Rejestru Sądowego, pod numerem KRS: 0000378167, NIP: 5492417339, REGON: 121463522.
                </p>
                <h2 className={"text-xl"}>2. Pliki Cookie</h2>
                <p>
                    Nasza strona internetowa korzysta z plików cookie, które są niewielkimi plikami tekstowymi
                    zapisywanymi na urządzeniu użytkownika podczas korzystania z witryny.
                </p>
                <ol className={"pl-4 space-y-2 list-outside"}>
                    <li>a. Wymagane pliki cookie Wykorzystujemy niezbędne pliki cookie, które są nieodzowne do
                        prawidłowego funkcjonowania systemu logowania. Z uwagi na ich niezbędność, nie można ich
                        wyłączyć. Pliki te umożliwiają użytkownikom bezpieczne zalogowanie się na konto, a także
                        utrzymanie sesji użytkownika.
                    </li>
                    <li>
                        b. Pliki cookie do personalizacji treści Na stronie stosujemy także opcjonalne pliki cookie,
                        które pozwalają na personalizację treści wyświetlanych użytkownikowi, na przykład w zależności
                        od jego preferencji i wcześniejszych działań w serwisie. Zgoda na ich używanie jest dobrowolna,
                        a użytkownik ma możliwość zarządzania nimi za pomocą ustawień przeglądarki.
                    </li>
                    <li>
                        c. Pliki cookie Google Analytics Nasza witryna korzysta z plików cookie Google Analytics, które
                        służą do analizy ruchu na stronie. Pozwalają nam one na monitorowanie liczby odwiedzin, czasu
                        spędzanego na stronie oraz identyfikowanie popularnych treści, co pomaga nam w optymalizacji
                        działania serwisu. Użytkownik może zrezygnować z tych plików cookie poprzez odpowiednie
                        ustawienia swojej przeglądarki lub korzystając z opcji wyłączenia śledzenia w ustawieniach
                        Google.
                    </li>
                </ol>
                <h2 className={"text-xl"}>3. Gromadzenie Danych Przeglądarki</h2>
                <p>
                    Podczas korzystania z naszej witryny zbieramy dane dotyczące systemu operacyjnego, z którego
                    korzysta użytkownik, oraz rodzaju przeglądarki internetowej. Informacje te pomagają nam w
                    optymalizacji działania strony oraz zapewnieniu jej zgodności z technologiami, których używają nasi
                    użytkownicy.
                </p>
                <h2 className={"text-xl"}>4. Adres IP i Lokalizacja Użytkownika</h2>
                <p>
                    Wykorzystujemy adresy IP użytkowników w celu przybliżonego ustalenia ich lokalizacji. Dane te są
                    używane ze względu na wymogi licencyjne zewnętrznych operatorów, z którymi współpracujemy. Nie
                    precyzujemy dokładnej lokalizacji użytkownika, a dane te służą wyłącznie do celów związanych z
                    przestrzeganiem regulacji umownych i licencyjnych.
                </p>
                <h2 className={"text-xl"}>5. Zmiany Polityki Prywatności</h2>
                <p>
                    Zastrzegamy sobie prawo do dokonywania zmian w niniejszej polityce prywatności. Wszelkie zmiany będą
                    publikowane na tej stronie i wchodzą w życie z chwilą ich opublikowania.
                </p>
                <p>
                    Jeśli masz jakiekolwiek pytania dotyczące naszej polityki prywatności, prosimy o kontakt pod
                    adresem:
                    <a href="mailto:rodo@beskidmedia.pl"
                        className={"text-sky-500 hover:text-sky-600 transition-colors"}> rodo@beskidmedia.pl</a>
                </p>
            </div>
        </MainLayout>
    );
};

export default PrivacyPolicy;